import React from 'react';
import { connect } from 'react-redux';

import DownloadApp from 'apps/auth/components/common/DownloadApp';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';

const GTDownloadPage = (props) => {
    return (
        <CommonPage backUrl={AUTH_SEND_MAIN_LINK} leftCloseIcon>
            <HeaderPanel title={props.title} isCentered />
            <DownloadApp
                info={props.info}
                googlePlayLink={props.googlePlayLink}
                appleStoreLink={props.appleStoreLink}
                huaweiGalleryLink={props.huaweiGalleryLink}
            />
        </CommonPage>
    );
};

const mapStateToProps = (state) => {
    return {
        googlePlayLink: state.extra.googleLink,
        appleStoreLink: state.extra.appleLink,
        huaweiGalleryLink: state.extra.huaweiLink,
        title: state.messages.pageMessages.downloadPageTitle,
        info: state.messages.pageMessages.downloadPageInfo,
    };
};

export default connect(mapStateToProps)(BasePage(GTDownloadPage));
